import { Component, EventEmitter, Input, Output } from '@angular/core';
import { LucideAngularModule, LucideIconProvider, LUCIDE_ICONS, icons } from 'lucide-angular';

@Component({
  selector: 'app-admin-crm-delete-lead-modal',
  standalone: true,
  imports: [LucideAngularModule],
  providers: [{ provide: LUCIDE_ICONS, multi: true, useValue: new LucideIconProvider(icons) }],
  templateUrl: './admin-crm-delete-lead-modal.component.html',
})
export class AdminCrmDeleteLeadModalComponent {
  @Input({ required: true }) open = false;
  @Input({ required: true }) leadLabel = '';
  @Input() deleting = false;

  @Output() cancelled = new EventEmitter<void>();
  @Output() confirmed = new EventEmitter<void>();

  onBackdropClick(): void {
    if (!this.deleting) this.cancelled.emit();
  }
}
